import { render, staticRenderFns } from "./Abbonamenti.vue?vue&type=template&id=3421e4fa&"
import script from "./Abbonamenti.vue?vue&type=script&lang=js&"
export * from "./Abbonamenti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports